import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "../css/Names.css";

const NamePage = ({ names }) => {
  const navigate = useNavigate();
  const [isExiting, setIsExiting] = useState(false);

  const MIN_DISTANCE = 180;

  // Generate random positions ensuring they aren't too close
  const generateRandomPositions = () => {
    const positions = [];

    const getRandomPos = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const xBorder = [20, 110]; // px of width
      const yBorder = [40, 40]; // px of height

      // First get our random x,y within bordered area
      const totalWidthX = width  - xBorder[0] - xBorder[1];
      const totalHeightY = height  - yBorder[0] - yBorder[1];
      let x = Math.random() * (totalWidthX);
      let y = Math.random() * (totalHeightY);

      // Shift to account for borders
      x += xBorder[0];
      y += yBorder[0];

      return {
        x: x,
        y: y,
      };
    };

    for (let i = 0; i < names.length; i++) {
      let pos = getRandomPos();
      let safe = false;
      let attempts = 0;

      while (!safe && attempts < 200) {
        pos = getRandomPos();
        const currentPos = pos;
        safe = positions.every(
          (p) => Math.hypot(p.x - currentPos.x, p.y - currentPos.y) > MIN_DISTANCE
        );
        attempts++;
      }

      positions.push(pos);
    }

    return positions;
  };

  const randomPositions = generateRandomPositions();

  const handleClick = (name) => {
    setIsExiting(true);
    window.dispatchEvent(new Event("namesExitStart"));
    setTimeout(() => {
      navigate(`/collections/${name.toLowerCase()}`);
    }, 500);
  };

  return (
    <div className="names-container">
      <div className="names-list">
        <AnimatePresence>
          {!isExiting &&
            names.map((name, i) => {
              const pos = randomPositions[i];
              const floatRange = 30;
              const duration = 6 + Math.random() * 4;

              return (
                <motion.div
                  key={name}
                  initial={{ opacity: 0, y: pos.y + 600, x: 0 }}
                  animate={{ opacity: 1, y: pos.y, x: pos.x }}
                  exit={{
                    y: pos.y - 600,
                    opacity: 0,
                    transition: { duration: 0.7, ease: "easeIn" },
                  }}
                  transition={{
                    duration: 0.8,
                    delay: i * 0.1,
                    ease: "easeOut",
                  }}
                  style={{ position: "absolute" }}
                >
                  {/* Inner layer for continuous floating */}
                  <motion.div
                    animate={{
                      x: [
                        0,
                        Math.random() * floatRange - floatRange / 2,
                        -Math.random() * floatRange + floatRange / 2,
                        0,
                      ],
                      y: [
                        0,
                        Math.random() * floatRange - floatRange / 2,
                        -Math.random() * floatRange + floatRange / 2,
                        0,
                      ],
                    }}
                    transition={{
                      x: {
                        repeat: Infinity,
                        repeatType: "mirror",
                        duration,
                        ease: "easeInOut",
                      },
                      y: {
                        repeat: Infinity,
                        repeatType: "mirror",
                        duration: duration + 1,
                        ease: "easeInOut",
                      },
                    }}
                  >
                    <div
                      className="names-button"
                      onClick={() => handleClick(name)}
                    >
                      {name}
                    </div>
                  </motion.div>
                </motion.div>
              );
            })}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default NamePage;